export default __webpack_public_path__ + "static/media/icon-apis.1b5c3842.svg";